import { useTranslation } from 'react-i18next';

import {
  getManualActionURL,
  getVariableActionURL,
  isManualActionURL,
  RichMessageBlock,
} from '../../../line-message-form';
import { LineMessageBlock } from '../shared';

export const LineMessagePreviewRichMessage = ({ image, actionUrl }: RichMessageBlock) => {
  const { t } = useTranslation('crm');
  const manualUrl = getManualActionURL(actionUrl);
  const variableUrl = getVariableActionURL(actionUrl);
  const url = isManualActionURL(actionUrl) ? manualUrl : variableUrl;

  return (
    <LineMessageBlock.Container title={t('crm.lineMessagePreview.richMessage.title')}>
      <li className="crm-line-message-preview__list-item" key={`rich-message-${image?.name}`}>
        <LineMessageBlock.Image imageUrl={image?.src ?? ''} />
        <LineMessageBlock.UrlPreview url={url} />
      </li>
    </LineMessageBlock.Container>
  );
};
